import './HistoryStepEvents.scss';

/**
 * Lista de eventos de un paso del historial
 * @param events - Eventos a mostrar
 */
export const HistoryStepEvents = ({ events }: IHistoryStepEventsProps) => {
  const hasEvents = !!events?.length;
  const containerClass = hasEvents ? 'historyStepEvents' : 'historyStepEvents historyStepEventsEmpty';

  if (!hasEvents) {
    return (
      <div className={containerClass}>
        <div className="emptyEventsSpacer"></div>
      </div>
    );
  }

  return (
    <div className={containerClass}>
      {events.map((event, eventIdx) => (
        <div key={eventIdx} className="eventItem">
          <div className="eventConnectorLine"></div>
          <div className="eventContent">
            <div className="eventCircle"></div>
            <div className="eventDetails">
              <span className="eventTitle">{event.title}</span>
              {event.date && <span className="eventDate">{event.date}</span>}
              {event.description && <p className="eventDescription">{event.description}</p>}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export interface IHistoryEventItem {
  title: string;
  date: string | null;
  description?: string;
}

interface IHistoryStepEventsProps {
  events?: IHistoryEventItem[];
}
